import * as Sentry from '@sentry/react';

const env = import.meta.env;
const isDev = import.meta.env.DEV;

// const logger = makeLogger("Sentry");
console.log(`[Sentry] Initializing in mode: ${import.meta.env.MODE}`);
console.log({
	mode: import.meta.env.MODE,
	nodeEnv: process.env.NODE_ENV,
	dev: import.meta.env.DEV,
	prod: import.meta.env.PROD,
});

export function configureSentry() {
	Sentry.init({
		dsn: env.VITE_SENTRY_DSN,
		enabled: !isDev,
		environment: import.meta.env.MODE,
		// For example, automatic IP address collection on events
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: true,
				blockAllMedia: true,
			}),
		],

		tracesSampleRate: isDev ? 0.0 : 0.05,
		replaysSessionSampleRate: isDev ? 0.1 : 0.2,
		replaysOnErrorSampleRate: isDev ? 0.1 : 1.0,

		tracePropagationTargets: ['localhost'],
	});
}
